/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterV = createReactComponent("letter-v", "IconLetterV", [
  ["path", { d: "M6 4l6 16l6 -16", key: "svg-0" }]
]);

export { IconLetterV as default };
//# sourceMappingURL=IconLetterV.js.map
